<template>
  <el-form v-if="!data.editorPageId">
    <el-form-item label="名称">
      <el-input v-model="data.name"></el-input>
    </el-form-item>
    <el-form-item label="宽度">
      <el-input v-model="data.width"></el-input>
    </el-form-item>
    <el-form-item label="高度">
      <el-input v-model="data.height"></el-input>
    </el-form-item>
    <el-form-item label="内边距(padding)">
      <el-input v-model="data.padding"></el-input>
    </el-form-item>
  </el-form>
  <mw-inner-page noWrap v-else :pageId="data.editorPageId" :params="data"></mw-inner-page>

</template>

<script>
    export default {
        name: "item-wrapper-editor",
        props:["data","params"],
        mounted(){
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/components/extend/layout/designer/item-wrapper-editor.vue